import React from 'react';
import { Form } from 'react-bootstrap';

interface FilterBadge {
	value: string;
	title: string;
}

interface FilterBadgesProps {
	title?: string;
	filters: FilterBadge[];
	checkedValues: string[];
	onChange(event: React.ChangeEvent<HTMLInputElement>): void;
	className?: string;
}

export const FilterBadges = ({ title, filters, checkedValues, onChange, className }: FilterBadgesProps) => {
	return (
		<div className={className}>
			{title && <h3 className="mb-3">{title}</h3>}
			<div>
				{filters.map((filter, index) => {
					return (
						<Form.Check key={index} inline id={filter.value} bsPrefix="hackett-form__check--badge">
							<Form.Check.Input
								type="checkbox"
								value={filter.value}
								onChange={onChange}
								checked={checkedValues.includes(filter.value)}
							/>
							<Form.Check.Label data-title={filter.title}>{filter.title}</Form.Check.Label>
						</Form.Check>
					);
				})}
			</div>
		</div>
	);
};
